import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Headline } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { useStats } from "_contexts/useStats";
import { useGTM } from "_hooks/useGTM";
import "./Screening.scss";

function Screening(props) {
  const navigate = useNavigate();
  const { isPreview, settings } = useSettings();
  const { updateStats, visitorId } = useStats();
  const { gtmEvent } = useGTM();
  const [question, setQuestion] = useState(0);
  const [failed, setFailed] = useState(false);

  const pageSettings = props.settings?.settings;
  const currentQuestion = pageSettings.questions[question];
  const handleAnswer = (answer, event) => {
    // Remove focus from the button to prevent stuck focus state
    if (event?.currentTarget) {
      event.currentTarget.blur();
    }

    const isLastQuestion = pageSettings.questions?.length === question + 1;
    // accepted_response uses ||| as delimiter (with comma fallback for legacy data)
    const acceptedResponses = currentQuestion.accepted_response
      ? currentQuestion.accepted_response.split(
          currentQuestion.accepted_response.includes("|||") ? "|||" : ","
        )
      : [];
    const isAccepted = acceptedResponses.includes(answer);

    if (isAccepted) {
      setQuestion(!isLastQuestion ? question + 1 : question);
    } else {
      setQuestion(!isLastQuestion ? question + 1 : question);
      setFailed(true);
    }
    if (isLastQuestion) {
      setTimeout(handleNext, 10);
    }
  };

  const handleNext = async () => {
    if (isPreview) {
      navigate(`/${props?.settings?.next}`);
      return;
    }

    // Track screening completion stats using visitor_id
    await updateStats({
      visitor_id: visitorId,
      self_enrollment_id: settings.id,
      page: props?.settings?.name,
      drop_off_page: props?.settings?.name,
    });

    localStorage.setItem("pp_qualify", failed ? "no" : "yes");
    if (failed) {
      gtmEvent("screening_failed");
      navigate(`/contact-us`);
      return;
    }
    gtmEvent("screening_passed");
    navigate(`/${props?.settings?.next}`);
  };

  return (
    <Card id="screening">
      <Headline>{currentQuestion.question}</Headline>
      <div className="initial-actions">
        {currentQuestion.options.map((option, i) => (
          <Button
            key={`screening-option-${i}`}
            type="blanco"
            size="large"
            block
            onClick={(e) => handleAnswer(option, e)}
          >
            {option}
          </Button>
        ))}
      </div>
    </Card>
  );
}

export default Screening;
